import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import saveAs from 'file-saver';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../../services/common.service';
import { ReportManagementService } from '../../../../services/report-management.service';
import { ReportService } from '../../../../services/report.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { ReportsService } from '../../../../services/reports.service';

interface User {
  userId: string;
  name: string;
  email?: string;
  phone?: string;
  administrator: boolean;
  inspections: boolean;
  oa: boolean;
  airCompliance: boolean;
  leadEngineer: boolean;
  engineer: boolean;
}

@Component({
    selector: 'app-inspector-installed-tlr-report',
    imports: [FormsModule, CommonModule,
        DropdownModule, CheckboxModule, ButtonModule, NextPage,
        TableModule, ChartModule, CalendarModule,
        RouterModule],
    providers: [DatePipe],
    templateUrl: './inspector-installed-tlr-report.component.html',
    styleUrl: './inspector-installed-tlr-report.component.scss'
})

export class InspectorInstalledTlrReportComponent {


  isShowMainBlock: boolean = false;
  showDateRange: boolean = true;
  showDetailsBlock: boolean = false;
  sub: Subscription | undefined;
  paramSub: Subscription | undefined;
  showStartCalendar: boolean = false;

  reportTLRStatusPageLoadItems: any;
  criteriaData: any;
  tlrStatusReport: any;
  titleName: string = '';
  sectionData = [
    { label: 'ALL', value: 'All' },
    { label: 'repairTypes', value: 'repairTypes' }]
  chartData: {
    labels: any; datasets: any;
  } = {
      labels: undefined,
      datasets: undefined
    };

  divisions = [];
  repairTypes = [
  ];
  section = [];
  plant = [];
  associatedUnit = [];
  ldar = [];
  manageLeaksItems = [];
  materialStateItems = [];
  inspectorUserCAi: any
  services: any = [];

  graphFlag:string = 'G'; // Default value for GraphFlag


  filters = {
    GraphFlag: 'G',
    // UserCAI: '', // Fill with actual user CAI
    InspCAI: '', // Fill with actual inspector CAI
    FacilityID: '', // Fill with actual facility ID
    Last7DaysFlag: true, //'Y' or 'N' based on dateRangeChecked
    StartDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    EndDate: new Date(),
    RepairTypeName: 'ALL',
    DivisionName: 'ALL',
    manageLeaksItems: 'ALL',
    materialStateItems: 'ALL',
    SectionName: 'ALL',
    PlantName: 'ALL',
    AssocPlantShutdown: 'ALL',
    LDARFlag: 'ALL',
    LeakingName: 'ALL',
    // vapourLiquid: 'ALL',
    Service: [],
    MaterialStateName: 'ALL'
  }

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          color: 'black',
          font: {
            weight: 'bold'
          },
        },
        beginAtZero: true
      },
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false, // Disable auto skipping of labels
          color: 'black',

          font: {
            weight: 'bold'
          },
        },

      }
    },
    plugins: {

      title: {
        display: true,
        text: '',
        font: {
          size: 20
        },
        color: '#333'
      }
      ,
      legend: {
        labels: {
          color: 'black',
          font: {
            weight: 'bold',
          }
        },
        position: 'bottom'

      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        formatter: function (value: number, context: any) {
          return value.toString();
        },
        font: {
          weight: 'bold'
        }
      }
    }
  }
  stausReportDataDetails: any[] = [];
  plugins = [ChartDataLabels];
  searchPageTitle: string = '';
  constructor(private route: ActivatedRoute,
    public reportService: ReportService,
    private router: Router,
    private reports: ReportsService,
    private commonService: CommonService,
    public reportManagementService: ReportManagementService,
    private datePipe: DatePipe  // Add DatePipe to constructor

  ) { 

    this.filters.InspCAI = this.commonService.getUserCai(); // Get the current user's CAI
  }
  ngOnInit() {
    this.reportService.getFilterListData().subscribe({
      next: (data: any) => {
        this.reportTLRStatusPageLoadItems = data;
        this.repairTypes = data.repairTypeItems;
        this.divisions = data.divisionItems;
        this.section = data.sectionItems;
        this.plant = data.plantItems;
        this.associatedUnit = data.associatedPlantItems;
        this.ldar = data.ldarItems;
        this.manageLeaksItems = data.manageLeaksItems;
        this.materialStateItems = data.materialStateItems;
        this.services = data.services.filter((item: any) => item.value !== 'ALL');
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      }
    });

    this.paramSub = this.route.queryParams.subscribe(params => {

      params['showMainBlock'] ? this.isShowMainBlock = true : this.isShowMainBlock = false;
      params['showDetailsBlock'] ? this.showDetailsBlock = true : this.showDetailsBlock = false;

      this.graphFlag = params['graphFlag'] || 'G'; // Default to 'G' if not provided

      if (this.isShowMainBlock && this.showDetailsBlock) {
        this.setFilterDataFromLocalStorage();
        this.titleName = JSON.parse(localStorage.getItem('titleName') || '');
        this.loadStatusReportDetails();
      }
      if (this.isShowMainBlock && !this.showDetailsBlock) {
        this.setFilterDataFromLocalStorage();
        this.loadStatusReportData();

      }
    });

  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.paramSub) {
      this.paramSub.unsubscribe();
    }
    localStorage.removeItem('filters');
    localStorage.removeItem('reportTLRStatusPageLoadItems');
    localStorage.removeItem('titleName');

  }
  formatDate(date: Date): string {
    if (!date) return '';
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  setFilterDataFromLocalStorage() {
    this.filters = JSON.parse(localStorage.getItem('filters') || '{}');
    this.filters.StartDate = new Date(this.filters.StartDate);
    this.filters.EndDate = new Date(this.filters.EndDate);
    this.reportTLRStatusPageLoadItems = JSON.parse(localStorage.getItem('reportTLRStatusPageLoadItems') || '{}');

  }
  loadStatusReportData() {
    
    let StartDate = this.datePipe.transform(this.filters.StartDate, 'yyyy-MM-dd');
    let EndDate = this.datePipe.transform(this.filters.EndDate, 'yyyy-MM-dd');

    if(this.filters.Last7DaysFlag) {
      StartDate = this.datePipe.transform(new Date(new Date().setDate(new Date().getDate() - 7)), 'yyyy-MM-dd');
      EndDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
    
    let payload = {
      GraphFlag: 'G',
      UserCAI: this.commonService.getUserCai(), //this.commanService.getUserCai()// Replace with actual user CAI
      FacilityID: this.reportService.getCurrentFacilityId(),
      Last7DaysFlag: this.filters.Last7DaysFlag ? 'Y' : 'N',
      StartDate: StartDate,
      EndDate: EndDate,
      DivisionName: this.filters.DivisionName,
      SectionName: this.filters.SectionName,
      PlantName: this.filters.PlantName,
      AssocPlantShutdown: this.filters.AssocPlantShutdown,
      LDARFlag: this.filters.LDARFlag,
      LeakingName: this.filters.LeakingName,
      MaterialStateName: this.filters.MaterialStateName,
      RepairTypeName: this.filters.RepairTypeName,
      Service: this.filters.Service.length ? this.filters.Service : 'All',
      InspCAI: this.filters.InspCAI || 'All'
    };

    this.reports.GetInspectOpenTLRReport(payload).subscribe({
      next: (data: any) => {
        this.tlrStatusReport = data;
        this.chartData = {
          labels: data?.map((d: any) => d.TitleName),
          datasets: [
            {
              label: 'Total',
              data: data?.map((d: any) => d.TitleNumber),
              backgroundColor: '#bd1c1c',
              borderColor: '#bd1c1c',
              borderwidth: 1,
              //borderRadius: 20,
              barThickness: 80, // Set the bar thickness
              maxBarThickness: 80,// Set the maximum bar thickness
              borderSkipped: false,

            },
          ]
        }
        const formattedStartDate = this.datePipe.transform(this.filters.StartDate, 'MM/dd/yyyy');
        const formattedEndDate = this.datePipe.transform(this.filters.EndDate, 'MM/dd/yyyy');
        this.chartOptions.plugins.title.text = `TLR Status Report ${formattedStartDate} to ${formattedEndDate}`;
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      }
    });
  }

  TitleList: any = {
    "Total TLRs Installed": "T",
    "Total TLRs Installed without Operations Data": "O",
    "Total TLRs Inspected and Installed": "I",
    "Total TLRs Engineered and Installed": "E",
  }

  getDetails(titleName: any) {
    this.titleName = titleName;
    localStorage.setItem('titleName', JSON.stringify(titleName));
    const queryParams = { showDetailsBlock: true, graphFlag: this.TitleList[titleName] || '' };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge', // This will merge the new query params with existing ones
      skipLocationChange: false // Set to true if you don't want to update the browser URL
    });

  }

  runReport() {
    this.isShowMainBlock = true;
    this.filters = this.filters;
    localStorage.setItem('filters', JSON.stringify(this.filters));
    localStorage.setItem('reportTLRStatusPageLoadItems', JSON.stringify(this.reportTLRStatusPageLoadItems));
    ;

    const queryParams = { showMainBlock: true, };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge', // This will merge the new query params with existing ones
      skipLocationChange: false // Set to true if you don't want to update the browser URL
    });
  }

  getFullTitle(shortName: string): string {
    for (const [fullTitle, code] of Object.entries(this.TitleList)) {
      if (code === shortName) {
        return fullTitle;
      }
      break;
    }
    return '';
  }
  loadStatusReportDetails() {
    
      let StartDate = this.datePipe.transform(this.filters.StartDate, 'yyyy-MM-dd');
      let EndDate = this.datePipe.transform(this.filters.EndDate, 'yyyy-MM-dd');

      if(this.filters.Last7DaysFlag) {
        StartDate = this.datePipe.transform(new Date(new Date().setDate(new Date().getDate() - 7)), 'yyyy-MM-dd');
        EndDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      }

    let payload = {
      GraphFlag: this.graphFlag,
      UserCAI: sessionStorage.getItem('currentUser'), // Replace with actual user CAI
      FacilityID: this.reportService.getCurrentFacilityId(),
      Last7DaysFlag: this.filters.Last7DaysFlag ? 'Y' : 'N',
      StartDate: StartDate,
      EndDate: EndDate,
      DivisionName: this.filters.DivisionName,
      SectionName: this.filters.SectionName,
      PlantName: this.filters.PlantName,
      AssocPlantShutdown: this.filters.AssocPlantShutdown,
      LDARFlag: this.filters.LDARFlag,
      LeakingName: this.filters.LeakingName,
      MaterialStateName: this.filters.MaterialStateName,
      RepairTypeName: this.filters.RepairTypeName,
      Service: this.filters.Service.length ? this.filters.Service : 'All',
      InspCAI: this.filters.InspCAI || 'All'
    };

    this.reports.GetInspectOpenTLRReport(payload).subscribe({
      next: (data: any) => {
        this.stausReportDataDetails = data;
        this.showDetailsBlock = true;
      },
      error: (error: any) => {
        console.error('Error fetching data:', error);
      }
    });
  }

  getFormateDate(date: any): any {
    if (!date) return '';
    let dateT: any = this.datePipe.transform(date, 'yyyy-MM-dd');
    let dateF = dateT?.split('-');
    return dateF[2] + '/' + dateF[1] + '/' + dateF[0];
  }
  
  GetInspectOpenTLRReportExcel() {
  
    let StartDate = this.datePipe.transform(this.filters.StartDate, 'yyyy-MM-dd');
    let EndDate = this.datePipe.transform(this.filters.EndDate, 'yyyy-MM-dd');

    if(this.filters.Last7DaysFlag) {
      StartDate = this.datePipe.transform(new Date(new Date().setDate(new Date().getDate() - 7)), 'yyyy-MM-dd');
      EndDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }

    let payload = {
      GraphFlag: this.graphFlag,
      UserCAI: this.commonService.getUserCai(),
      FacilityID: this.reportService.getCurrentFacilityId(),
      Last7DaysFlag: this.filters.Last7DaysFlag ? 'Y' : 'N',
      StartDate: StartDate,
      EndDate: EndDate,
      DivisionName: this.filters.DivisionName,
      SectionName: this.filters.SectionName,
      PlantName: this.filters.PlantName,
      AssocPlantShutdown: this.filters.AssocPlantShutdown,
      LDARFlag: this.filters.LDARFlag,
      LeakingName: this.filters.LeakingName,
      MaterialStateName: this.filters.MaterialStateName,
      RepairTypeName: this.filters.RepairTypeName,
      Service: this.filters.Service.length ? this.filters.Service : 'All',
      InspCAI: this.filters.InspCAI
    };

    this.reports.GetInspectOpenTLRReportExcel(payload).subscribe({
      next: (fileData) => {
        if (fileData) {
          saveAs(fileData, 'statusTlreport.xlsx');
        }

      },
      error: (err) => {
        console.error('Error fetching report details:', err);
      }
    })
  }
  exportToExcel() {
    this.commonService.exportToExcel(this.stausReportDataDetails, 'status.xlsx');
  }

  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }
  selectData(event: any) {
    const label = this.chartData.labels[event.element.index];
    this.getDetails(label)
  }

  getLevel(value: any, field: string) {
    if (field === 'plant') {
      let tmp: any = this.plant.find((each: any) => each.value === value);
      return tmp?.label;
    } else if (field === 'associatedUnit') {
      let tmp: any = this.associatedUnit.find((each: any) => each.value === value);
      return tmp?.label;
    } else {
      return '';
    }
  }
}